// C12 · مقدّمي الخدمة (providers — read). Per-screen i18n namespace, merged at load
// time by i18n.ts's require.context('./screens'). Full ar/en parity for every key the
// providers.vue view binds.
module.exports = {
  ar: {
    providers: {
      title: 'مقدّمي الخدمة',
      crumb: 'شبكة مقدّمي الخدمة',
      loading: 'جارٍ التحميل…',
      error: 'حدث خطأ أثناء تحميل شبكة مقدّمي الخدمة',
      empty: 'لا يوجد مقدّمو خدمة مطابقون للبحث',
      reference:
        'يحدّد هذه الشبكة المؤمِّن (شركة التأمين) من لوحة تحكم الأدمن — العرض هنا مرجعي فقط، وتتصفّح الشركة ما هو مشمول في بوليصتها.',
      searchPlaceholder: 'اسم / نوع / محافظة',
      filters: { all: 'الكل' },
      types: {
        hospital: 'مستشفى',
        lab: 'معمل',
        pharmacy: 'صيدلية',
        radiology: 'مركز أشعة',
        dental: 'أسنان',
        clinic: 'عيادة',
      },
      cols: {
        provider: 'مقدّم الخدمة',
        type: 'النوع',
        city: 'المحافظة',
        network: 'الشبكة',
        status: 'الحالة',
      },
      status: { active: 'متعاقد', suspended: 'موقوف' },
      details: 'تفاصيل',
      detailNote: 'مشمولة في بوليصة شركتك — يحدّد المؤمِّن الحالة والتغطية.',
      count: 'عرض {n} من {total} مقدّم خدمة مشمول',
    },
  },
  en: {
    providers: {
      title: 'Service Providers',
      crumb: 'Provider Network',
      loading: 'Loading…',
      error: 'Failed to load the provider network',
      empty: 'No providers match your search',
      reference:
        'This network is defined by the insurer from the admin dashboard — this view is reference only; the company browses what is covered by its policy.',
      searchPlaceholder: 'Name / type / city',
      filters: { all: 'All' },
      types: {
        hospital: 'Hospital',
        lab: 'Lab',
        pharmacy: 'Pharmacy',
        radiology: 'Imaging Center',
        dental: 'Dental',
        clinic: 'Clinic',
      },
      cols: {
        provider: 'Provider',
        type: 'Type',
        city: 'City',
        network: 'Network',
        status: 'Status',
      },
      status: { active: 'Contracted', suspended: 'Suspended' },
      details: 'Details',
      detailNote: 'Covered by your company policy — status and coverage are set by the insurer.',
      count: 'Showing {n} of {total} covered providers',
    },
  },
};
